<script lang="ts" setup>

</script>

<template>
    <div class="rounded-[3rem] p-16 bg-[#3e3c94] text-white text-center h-full w-full">
        <slot></slot>
    </div>
</template>